import { ORG, DIRECTORY } from "@/data/tools";
import { LogoMark } from "@/components/Reveal";

const SUPPORTING = ["SENDCOs", "Inclusion Leads", "Headteachers", "Senior Leaders", "Governors"];
export const TAGLINE = "Supporting schools, families and professionals through practical SEND resources, toolkits and insight.";
export const HELPS = ["Review current SEND provision", "Identify strengths and priorities", "Support strategic planning", "Reflect on partnership working", "Develop practical improvement actions"];
export const DEVELOPMENTS = ["SEND Toolkits", "School Dashboards", "Parent Resources", "SEND Self-Assessment Tools", "SEND Development Planning Resources", "Professional Development Resources"];
export const PRIVACY = [
  "This downloadable resource does not require registration.",
  "If you choose to provide feedback or contact us, please do not include pupil-identifiable information, safeguarding information, special category data or confidential case information.",
  "Any information voluntarily submitted will be processed in accordance with applicable UK data protection legislation and our privacy information.",
  `The SEND Accountability Project Ltd is registered with the Information Commissioner's Office. ICO Registration: ${ORG.ico}`,
];
export const DISCLAIMER = [
  "This resource is intended to support professional reflection, planning and discussion.",
  "It does not constitute legal advice, statutory guidance, educational psychology advice, consultancy services or professional recommendations.",
  "Schools remain responsible for ensuring compliance with all relevant legislation, statutory guidance and local procedures.",
  "Whilst reasonable efforts are made to maintain accuracy, The SEND Accountability Project Ltd accepts no liability for decisions made solely on the basis of this resource.",
];

export const QsHeader = () => (
  <div className="qs-print-head"><span>The SEND Accountability Project</span><span>SENDCO Quick Start Pack</span></div>
);

export const QsFooter = () => (
  <p className="text-[9.5px] leading-snug">
    <strong>{ORG.name}</strong> · {ORG.web} · {ORG.director} · {ORG.phone} · ICO Registration: {ORG.ico} | Company No. {ORG.company}
  </p>
);

export const QsCover = () => (
  <div className="print-cover qs-cover">
    <LogoMark className="h-20 w-20" />
    <p className="mt-10 text-sm font-bold tracking-[0.25em]">THE SEND ACCOUNTABILITY PROJECT</p>
    <h1 className="mt-4 font-display text-6xl font-medium leading-[1]">Free SENDCO<br />Quick Start Pack</h1>
    <p className="mt-5 text-2xl italic">Practical Reflection Tools for Schools</p>
    <p className="mt-10 font-bold">Supporting:</p>
    <ul className="mt-2 grid grid-cols-2 gap-1 text-lg">{SUPPORTING.map((s) => <li key={s}>✓ {s}</li>)}</ul>
    <p className="qs-gold mt-12 font-bold">Practical SEND Resources • Toolkits • Dashboards • Insights</p>
    <p className="mt-10 font-bold">{ORG.name}</p>
    <p>{TAGLINE}</p>
  </div>
);

export const QsWelcomePages = () => (
  <div className="print-only-block">
    <h2 className="font-display text-4xl">Welcome</h2>
    <p className="mt-3">Thank you for downloading this free SENDCO Quick Start Pack.</p>
    <p className="mt-2">The SEND Accountability Project develops practical resources, tools and insights designed to support schools, families and professionals working with children and young people with SEND.</p>
    <p className="mt-2">This pack has been designed to help schools:</p>
    <ul className="mt-1 list-disc pl-6">{HELPS.map((h) => <li key={h}>{h}</li>)}</ul>
    <p className="mt-2">The resources may be used independently or as part of wider SEND development activity.</p>
    <h3 className="mt-6 font-display text-2xl">Useful links</h3>
    <ul className="mt-1">{DIRECTORY.filter((d) => d.url).map((d) => <li key={d.name}><strong>{d.name}:</strong> {d.url}</li>)}</ul>
    <h2 className="mt-8 font-display text-3xl">About The SEND Accountability Project</h2>
    <p className="mt-2">The SEND Accountability Project exists to support improved outcomes for children and young people with SEND through practical resources, accessible tools and collaborative approaches.</p>
    <p className="mt-2">Current and future developments include:</p>
    <ul className="mt-1 grid grid-cols-2 gap-1">{DEVELOPMENTS.map((d) => <li key={d}>✓ {d}</li>)}</ul>
  </div>
);

export const QsBackPages = () => (
  <div className="print-only-block" style={{ breakBefore: "page" }}>
    <h2 className="font-display text-4xl">Help Shape Future Resources</h2>
    <p className="mt-2">Thank you for using this resource. The SEND Accountability Project welcomes feedback from schools, families and professionals to help inform future development.</p>
    <p className="mt-5 font-bold">What was the most useful section?</p>
    <div className="qs-line" /><div className="qs-line" /><p className="mt-4 font-bold">What additional resources would support your setting?</p>
    <div className="qs-line" /><div className="qs-line" /><div className="qs-line" />
    <p className="mt-4 font-bold">Would you be interested in learning more about future resources?</p>
    <p className="mt-1">☐ Yes &nbsp;&nbsp; ☐ No &nbsp;&nbsp; ☐ Maybe</p>
    <p className="mt-3">Or leave feedback online: {typeof window !== "undefined" ? `${window.location.origin}/quick-start#feedback` : ""}</p>
    <h3 className="mt-6 font-display text-2xl">Contact us</h3>
    <p>{ORG.director} · {ORG.datalead} · {ORG.phone} · {ORG.web}</p>
    <h3 className="mt-6 font-display text-xl">Privacy notice</h3>
    {PRIVACY.map((p) => <p key={p} className="mt-1 text-sm">{p}</p>)}
    <h3 className="mt-4 font-display text-xl">Disclaimer</h3>
    {DISCLAIMER.map((p) => <p key={p} className="mt-1 text-sm">{p}</p>)}
    <p className="mt-6 text-sm"><strong>{ORG.name}</strong> · Company No. {ORG.company} · ICO Registration: {ORG.ico} · Registered Office: {ORG.office}</p>
    <p className="text-sm">{TAGLINE}</p>
  </div>
);
